var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueReferalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2621 18.4592C24.8669 25.5806 17.3004 29.5036 10.1506 27.4532L5.84161 29.5752L6.42155 25.7678C1.15476 22.383 -1.35278 15.741 0.733955 9.53676C3.19783 2.21123 11.1337 -1.72992 18.4592 0.733955C25.7848 3.19783 29.7259 11.1337 27.2621 18.4592ZM10.4531 24.5377C16.2739 26.4955 22.5797 23.3639 24.5374 17.5431C26.4952 11.7223 23.3636 5.41649 17.5428 3.45871C11.722 1.50093 5.4162 4.63254 3.45843 10.4533C1.50065 16.2742 4.63226 22.5799 10.4531 24.5377ZM20.3792 13.3835C20.3792 12.5334 19.6901 11.8443 18.84 11.8443H15.9395V8.67406C15.9395 7.7495 15.19 7 14.2655 7C13.3409 7 12.5914 7.7495 12.5914 8.67406V11.8443H9.67868C8.82863 11.8443 8.13953 12.5334 8.13953 13.3835C8.13953 14.2335 8.82863 14.9226 9.67868 14.9226H12.5914V18.3259C12.5914 19.2505 13.3409 20 14.2655 20C15.19 20 15.9395 19.2505 15.9395 18.3259V14.9226H18.84C19.6901 14.9226 20.3792 14.2335 20.3792 13.3835Z",
    fill: "#0F75FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueReferalIcon);
export default __webpack_public_path__ + "static/media/blue_referal_icon.ed192733f95f2308be62d0bf3e250c09.svg";
export { ForwardRef as ReactComponent };